import Color from 'color';
export const createColorState = _ref => {
  let {
    currentColor,
    initialColor,
    colorThemeMap,
    setColor,
    compId
  } = _ref;
  return {
    compId,
    hasChanged: hasColorChanged(initialColor, currentColor),
    hex: currentColor.hex(),
    lightness: currentColor.lightness(),
    onLightnessChange: lightness => {
      const color = adjustColorLightness(currentColor, lightness);
      setColor(color);
    },
    revert: () => {
      setColor(initialColor);
    },
    setColor: color => {
      const resolvedColor = isThemeId(color) ? colorThemeMap[color] : color;
      setColor(new Color(resolvedColor));
    }
  };
};
const adjustColorLightness = (baseColor, lightness) => new Color(baseColor).lightness(lightness);
const hasColorChanged = (color1, color2) => new Color(color1).hex() !== new Color(color2).hex();
const isThemeId = color => color.startsWith('color_');
//# sourceMappingURL=create-color-state.js.map